import * as actionTypes from './actionTypes';
import { IPinLoginResponse } from '../../hooks/auth/mutations';
import { IIntercomSession } from '../../interfaces/Intercom';

export const setUserAction = (obj) => ({
  type: actionTypes.SET_USER,
  token: obj.token,
  user: obj.user,
  company: obj.company,
  hasMultiStore: obj.hasMultiStore,
  role: obj.role,
  isCompanyAdmin: obj.isCompanyAdmin,
  cashierBox: obj.cashierBox,
  store: obj.store,
  name: obj.name,
  stripeCustomerId: obj.stripeCustomerId,
  permission: obj.permission,
  intercom: obj.intercom ?? null
});

export const clearUserAction = () => ({
  type: actionTypes.CLEAR_USER
});

export const switchUserAction = (obj: IPinLoginResponse) => ({
  type: actionTypes.SWITCH_USER,
  user: obj.user,
  company: obj.company,
  hasMultiStore: obj.user.hasMultiStore,
  role: obj.user.role,
  isCompanyAdmin: obj.user.isCompanyAdmin,
  cashierBox: obj.user.cashierBox,
  token: obj.token,
  currencySymbol: obj.storeInfo.currencySymbol,
  store: obj.storeInfo,
  name: obj.user.name,
  stripeCustomerId: obj.user.stripeCustomerId,
  permission: obj.user.permission,
  intercom: obj.intercom ?? null
});

export const setIntercomTokenAction = (intercom: IIntercomSession) => ({
  type: actionTypes.SET_INTERCOM_TOKEN,
  intercom
});

export const setUserPrinter = (obj) => ({
  type: actionTypes.SET_USER_PRINTER,
  printer: {
    name: obj.name,
    paperSize: obj.paperSize
  }
});

export const setUserCompanyInfo = (obj) => ({
  type: actionTypes.SET_USER_COMPANY_INFO,
  company: {
    logoUrl: obj.logoUrl
  }
});
